import { StepIndicator } from 'src/Components/Instructions/StepIndicator';
import { AttachmentsViewer } from 'src/Components/Shared/AttachmentsViewer';
import { SlateRenderer } from 'src/Components/Shared/SlateRenderer';
import { SlateNode } from 'src/Components/Shared/SlateRenderer/SlateRenderer.types';

import styles from './InstructionDetailSection.module.scss';
import { Props } from './InstructionDetailSection.types';

const InstructionDetailSection = ({ index, section }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.titleLine}>
        <StepIndicator index={index} />
        <div className={styles.title}>{section.title}</div>
      </div>

      <div className={styles.content}>
        <SlateRenderer value={section.content as SlateNode[]} />
      </div>

      {section.attachments && <AttachmentsViewer attachments={section.attachments} />}
    </div>
  );
};

export default InstructionDetailSection;
